import { defineStore } from 'pinia';

import { useRootStore } from './root';

import {
  AggregationRepository,
  BulkGrantAggregationRegisterForm,
} from '@/repositories/generated';
import { BulkGrantAggregationUiFormSchema } from '@/validations';

type BulkGrantAggregationStoreState = {
  form?: BulkGrantAggregationRegisterForm;
};

export const useBulkGrantAggregationStore = defineStore('bulkGrantAggregation', {
  state: (): BulkGrantAggregationStoreState => ({
    form: undefined,
  }),
  actions: {
    async aggregate(form: BulkGrantAggregationUiFormSchema) {
      const rootStore = useRootStore();
      rootStore.isLoading = true;

      this.form = {
        startDateTime: form.startDateTime.toISOString(),
        endDateTime: form.endDateTime.toISOString(),
        criteria: form.criteria,
        filter: {
          walletServiceIds: form.filter.walletServices.map((value) => value.id),
          bulkGrantIds: form.filter.bulkGrants.map((value) => value.id),
        },
      };

      return AggregationRepository.registerBulkGrantAggregation({ requestBody: this.form })

        .finally(() => {
          rootStore.isLoading = false;
        });
    },
  },
});
